// PrivateRoute.js
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from './authContext';
import { hasAnyPermission, permissionsForPath } from './adminPermissions';

/**
 * PrivateRoute component to protect routes that require authentication.
 * @param {Object} props - Component properties.
 * @param {React.ComponentType} props.component - The component to render if authenticated.
 * @returns {JSX.Element} - A Route component that either renders the given component or redirects to root.
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
    const { isAuthenticated, user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>; // Or a loading spinner
    }

    return (
        <Route
            {...rest}
            render={props => {
                const required = permissionsForPath(props.location.pathname);
                return isAuthenticated && hasAnyPermission(user, required) ? (
                    <Component {...props} />
                ) : !isAuthenticated ? (
                    <Redirect to="/" />
                ) : (
                    <Redirect to="/admin" />
                )
            }}
        />
    );
};

export default PrivateRoute;
